import { render } from "./QueryRoleSelector.vue?vue&type=template&id=6071999e"
import script from "./QueryRoleSelector.vue?vue&type=script&lang=js"
export * from "./QueryRoleSelector.vue?vue&type=script&lang=js"

import "./QueryRoleSelector.vue?vue&type=style&index=0&id=6071999e&lang=scss"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__